<template>
    <div class="detail-layout"
        v-if="isAccountLoaded">
        <campaign-picture class="layout-picture"
            :imgClass="'default'"
            :campaignImage="detailController.campaign.pictures"></campaign-picture>

        <div class="layout-name">{{detailController.campaign.name}}</div>
        <div class="layout-point">
            <div v-html="getPointText(detailController.point, detailController.pointType)"></div>
        </div>

        <detail-and-condition
            :lbl="lbl"
            :userType="userType"
            :campaign="detailController.campaign"></detail-and-condition>

        <redeem-button
            id="redeem-btn"
            :isLogin="isLogin"
            :userPoint="point"
            :detailController="detailController"
            :lblRedeemBTN="lbl.redeem_button">
        </redeem-button>
    </div>
</template>
<script>
import Vue from 'vue';
//helper
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
//component
import CampaignPicture from "../detail/Picture.vue";
import DetailAndCondition from "../detail/DetailAndCondition.vue";
import RedeemButton from "../detail/RedeemButton.vue";

import { WebInterfaceController } from '../../controller/WebInterfaceController';
/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {number} locale (required) Current language.
 * @property {object} campaign (required) Campaign information.
 * Method
 * @method initialLayout Setup campaign information.
 * @method updateSelectedCampaignInfo Callback for subcampagin to update Campaign information.
 */
export default {
    name: "DefaultLayout",
    mixins: [
        AccountMixin
    ],
    components: {
        CampaignPicture,
        DetailAndCondition,
        RedeemButton
    },
    props: {
        lbl: Object,
        locale: Number,
        userType: String,
        detailController: Object
    },
    data: function() {
        return {
            trackingService: new TrackingService(this),
            trackingEventCategory: 'campaigndetail_page',
        };
    },
    created: function () {
        this.initialDetailControllerEvent();
        this.lblRedeemBTN = this.lbl.redeem_button;
    },
    methods: {
        //method
        initialDetailControllerEvent: function () {
            this.detailController.cbOpenWeb
                .onCallback(this.openWebsite);

            this.detailController.cbOpenSurvey
                .onCallback(() => {

                });

            this.detailController.cbCallApi
                .onCallback(() => {

                });

            this.detailController.cbShoppingCart
                .onCallback(this.openShoppingCart);

            this.detailController.cbRedeemSuccess
                .onCallback(data => {
                    this.$router.push(data.page);
                    this.trackingService.event(this.trackingEventCategory, 'click_redeem_submit', null, null);
                    console.log('redeem success click_redeem_submit');
                    
                });

            this.detailController.cbRedirect.onCallback((data) =>{
                this.$router.push('/horoscope/'+ data.id);
            });
        },
        //callback event
        openWebsite: function (campaign) {
            this.trackingService.event(this.trackingEventCategory, 'click_redeem_submit', null, null);
            console.log('redeem success click_redeem_submit');
            
            let webInterface = new WebInterfaceController(campaign);
            webInterface.openInterface();
            // if (!website) return;
            // let webUrl = website;
            // const isShowHeader = 'false';
            // const theme = 'cpffeed';
            // const suffledToken = Account.getTokenShuffle();

            // if (webUrl.indexOf('/Topup/InterfaceLanding') >= 0 ||
            //     webUrl.indexOf('/Landing/Ais') >= 0 ||
            //     webUrl.indexOf('/Landing/dtac') >= 0 ||
            //     webUrl.indexOf('starbucks') >= 0 ) {
            //     Account.setCacheCustom('isfromlanding', { page: 'interface' });
            // } else if (webUrl.indexOf('wondd') >= 0) {
            //     Account.setCacheCustom('isfromlanding', { page: 'wodd' });
            // } else {
            //     Account.setCacheCustom('isfromlanding', { page: 'other' })
            // }

            // webUrl += '&token=' + suffledToken
            //         + '&locale=' + this.locale
            //         + '&header=' + isShowHeader
            //         + '&theme=' + theme
            //         + '&return_url=' + encodeURIComponent(window.location.href);

            // // support history truemoney
            // if (webUrl.indexOf('wondd/truemoney') == -1 && webUrl.indexOf('truemoney') >= 0) {
            //     webUrl += '&history_url=' + encodeURIComponent(window.location.origin + '/history/burn');
            // }

            // window.location.href = webUrl;
        },
        openShoppingCart: function (website) {
            if(!website) return;

            var bzbsToken = Account.getToken();
            var localeCode = this.locale;
            var returnUrl = encodeURIComponent(window.location.href);
            var strUrl = '';
            var strLocale = '';
            var strEncryptToken = Util.shuffleToken(bzbsToken);
            switch(localeCode) {
                case 1033:
                    strLocale = 'E';
                    break;
                case 1054:
                    strLocale = 'T';
                    break;
            }

            if (this.campaign.website.indexOf('.buzzebees.com/payment/')) {
                var arrSplittedUrl = this.campaign.website.split('/payment');
                strUrl = `${Vue.bzbsConfig.bzbShoppingCartUrl}/payment${arrSplittedUrl[1]}&token=${strEncryptToken}&return_url=${returnUrl}&locale=${strLocale}`;
            } else {
                strUrl = `${website}&token=${strEncryptToken}&return_url=${returnUrl}&locale=${strLocale}`;
            }

            window.location = strUrl;
        },
        //util
        getPointText: function (point, pointType) {
            var pointTypeTxt = pointType && pointType != 'use'
                            ? this.lbl.detail.get_point
                            : this.lbl.detail.use_point;

            var pointUnit = this.locale === 1033 && point > 1
                        ? this.lbl.detail.point + 's'
                        : this.lbl.detail.point;

            return `${pointTypeTxt} <span class="points">${Util.formatNum(point)}</span> ${pointUnit}`;
        }
    }
};
</script>
<style lang="scss">
@import "@/module/Detail/component/layout/Layout.scss";
</style>
